import {
  Card,
  DataDisplay,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@compass/core";
import {
  SurveyReportAnswer,
  SurveyReportQuestion,
  SurveyReportResponse,
} from "generated/openApi";

import { useDispatch } from "react-redux";

export const SurveyReportReportResult = (props: {
  surveyReportResult: SurveyReportResponse;
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const renderAnswer = (answer: SurveyReportAnswer, index: number) => {

    return (
      <TableRow>
        <TableCell align="left">{answer.answer}</TableCell>
        <TableCell align="right">{answer.count}</TableCell>
        <TableCell align="right">{answer.percent?.toFixed(2)}%</TableCell>
      </TableRow>
    );
  };

  const renderTotal = (question: SurveyReportQuestion) => {
    return (
      <TableRow>
        <TableCell align="left" sx={{ fontWeight: 'bold' }}>Total Responses</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{question.totalResponse?.count}</TableCell>
        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{question.totalResponse?.percent?.toFixed(2)}%</TableCell>
      </TableRow>
    );
  };

  const renderQuestion = (question: SurveyReportQuestion, index: number) => {

    return (
      <Grid item xs={9}>
        <Grid container spacing="sm">
          <Grid item xs={12}>
            {question.questionContent && (<Typography fontWeight={theme.typography.fontWeightBold} sx={{ marginTop: "1em" }}>{`${question?.label}. ${question.questionContent}`}</Typography>)}
            {!question.questionContent && (<Typography fontWeight={theme.typography.fontWeightBold} sx={{ marginTop: "1em" }}>{question?.label}</Typography>)}
          </Grid>
          <Grid item xs={8}>
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" colorOverride="white" sx={{ backgroundColor: theme.palette.primary.main }}>Answer</TableCell>
                    <TableCell align="center" colorOverride="white" sx={{ backgroundColor: theme.palette.primary.main }}>Count #</TableCell>
                    <TableCell align="center" colorOverride="white" sx={{ backgroundColor: theme.palette.primary.main }}>Percent %</TableCell>
                  </TableRow>
                  {question.answers?.length! > 0 && question.answers?.filter(a => a.count > 0).map((a, index) => renderAnswer(a, index))}
                  {renderTotal(question)}
                </TableHead>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderNote = (note: string, index: number) => {
    return (
      <Grid key={index} item xs={9}>
        <Typography fontStyle="italic">{`${note}`}</Typography>
      </Grid>
    );
  };

  return (
    <Card header={"Survey"}>
      <Grid container spacing="sm">
        <Grid item xs={12}>
          <Grid direction="row" container spacing="lg">
            <Grid item xs={11}>
              <DataDisplay label="Survey Report">{`${props.surveyReportResult.reportTitle}`}</DataDisplay>
            </Grid>
            {props.surveyReportResult.notes?.length! > 0 && (
              <Grid item xs={11}>
                <Typography fontStyle="bold">{`Note:`}</Typography>
              </Grid>
            )}
            {props.surveyReportResult.notes?.length! > 0 && props.surveyReportResult.notes?.map((n, index) => renderNote(n, index))}
          </Grid>
        </Grid>

        {props.surveyReportResult.questions?.length! > 0 && props.surveyReportResult.questions?.map((q, index) => renderQuestion(q, index))}
      </Grid>
    </Card>
  );
};
